var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3565",
    "data-name": "Group 3565",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12240",
    "data-name": "Path 12240",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    fill: "#c2fae5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-3556018",
    transform: "translate(7.531 7.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12441",
    "data-name": "Path 12441",
    d: "M268.694,100.8a2.894,2.894,0,0,0-2.061.854l-4.86,4.86a4.639,4.639,0,0,0-1.368,3.3V112h2.187a4.638,4.638,0,0,0,3.3-1.368l4.863-4.863a2.916,2.916,0,0,0-2.061-4.975Zm.74,3.656-4.861,4.86a2.783,2.783,0,0,1-1.982.822h-.32v-.32a2.782,2.782,0,0,1,.819-1.982l4.863-4.863a1.048,1.048,0,1,1,1.48,1.48Z",
    transform: "translate(-256.669 -100.799)",
    stroke: "#c2fae5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12442",
    "data-name": "Path 12442",
    d: "M173.6,137.207h8.4a2.8,2.8,0,0,0,2.8-2.8v-3.735h-1.868v3.735a.934.934,0,0,1-.934.934h-8.4a.933.933,0,0,1-.934-.934V126a.934.934,0,0,1,.934-.934h3.735V123.2H173.6a2.8,2.8,0,0,0-2.8,2.8v8.4a2.8,2.8,0,0,0,2.8,2.8Z",
    transform: "translate(-170.8 -122.267)",
    stroke: "#c2fae5",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7c5c7ec3890e903e765df1cbc792411d.svg";
export { ForwardRef as ReactComponent };